(function () {
  'use strict';

  angular
    .module('app.product.price', [])
     /* @ngInject */
    .directive('productPrice', function () {
      return {
        restrict: 'E',
        require: {
          productCtrl: '^^productDetail'
        },
        bindToController: {
          jsonPrice: '=',
          prices: '<',
          txtFirstRange: '@',
          txtRange: '@',
          txtLastRange: '@'
        },
        /* @ngInject */
        controller: ["$timeout", function ($timeout) {
          var ctrl = this;

          ctrl.$onInit = function () {
            $timeout(function () {
              var prices = [{
                qty: 1,
                range: [0],
                HasDiscount: ctrl.jsonPrice.HasDiscount,
                Discount: ctrl.jsonPrice.Discount,
                HTDiscountedPrice: ctrl.jsonPrice.HTDiscountedPrice,
                TTCDiscountedPrice: ctrl.jsonPrice.TTCDiscountedPrice,
                HTPrice: ctrl.jsonPrice.HTPrice,
                TTCPrice: ctrl.jsonPrice.TTCPrice
              }];
              if (ctrl.jsonPrice.DegressivePrice) {
                var i = 0;
                _.each(ctrl.jsonPrice.DegressivePrice, function (item, key) {

                  prices[i].range.push(Number(key));
                  if (i === 0) {
                    prices[i].caption = ctrl.txtFirstRange.replace('{0}', String(key));
                  } else {
                    prices[i].caption = ctrl.txtRange.replace('{0}', String(prices[i].range[0])).replace('{1}', String(key - 1));
                  }

                  prices.push({
                    qty: Number(key),
                    range: [Number(key)],
                    caption: ctrl.txtLastRange.replace('{0}', String(key)),
                    HasDiscount: item.HasDiscount,
                    Discount: item.Discount,
                    HTDiscountedPrice: item.HTDiscountedPrice,
                    TTCDiscountedPrice: item.TTCDiscountedPrice,
                    HTPrice: item.HTPrice,
                    TTCPrice: item.TTCPrice
                  });

                  i++;
                });
              }
              ctrl.prices = prices;
              ctrl.productCtrl.setPricesData(prices, ctrl.jsonPrice.EcoContribution);
            });
          };
        }]
      };
    });

})();
